export default __webpack_public_path__ + "static/media/accommodations6_668.a85a38df.webp";